import * as React from "react";
const SvgSissors20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 5.055c0-1.73 1.41-3.12 3.14-3.12 1.72 0 3.13 1.41 3.12 3.14a3.14 3.14 0 0 1-1.293 2.526l2.216 1.308c2.389-1.41 4.65-2.746 4.797-2.834.87-.51 1.79-.67 2.48-.57h.01c.55.07 1.59.34 1.59.34l-7.031 4.154 7.021 4.146s-1.04.27-1.59.34v.01c-.69.1-1.61-.06-2.48-.57L9.182 11.09 6.96 12.403a3.107 3.107 0 0 1 1.29 2.522c0 1.73-1.39 3.14-3.12 3.14l.01-.01c-1.73 0-3.14-1.4-3.14-3.12 0-1.232.708-2.306 1.746-2.815L7.336 10 3.619 7.805a3.122 3.122 0 0 1-.153-.09l-.016-.01A3.136 3.136 0 0 1 2 5.055Zm4.37.01c0-.68-.56-1.24-1.24-1.24-.68 0-1.24.56-1.24 1.24 0 .68.56 1.24 1.24 1.24.68 0 1.24-.56 1.24-1.24Zm-1.24 11.11c-.68 0-1.24-.55-1.24-1.24s.55-1.24 1.24-1.24 1.24.55 1.24 1.24-.55 1.24-1.24 1.24Z",
      clipRule: "evenodd"
    })
  );
export default SvgSissors20Px;
